import { CourseBlock } from "../../../Pages/CourseTarget/courseBlocks";
import { MaterialList } from "../../../layoutPages/components/MaterialList";
import { MainCard } from "../../../layoutPages/components/MainCard";
import { mathsImg } from "./img";

const LEGACY_PDF = "http://www.pkps.edu.hk/09-10%20teachplan/final";

/** 數學科 > 網上學習資源 */
export const mathsResourcesBlocks: CourseBlock[] = [
    {
        type: "paragraph",
        title: "A. 數學「常用單位換算表」及小錦囊",
        titleSize: "h5",
        data: [
            <MaterialList
                data={[
                    { name: "數學科常用單位換算表(小二)", src: `${LEGACY_PDF}/pdf/ms/2.doc` },
                    { name: "數學科常用單位換算表(小三)", src: `${LEGACY_PDF}/pdf/ms/3.doc` },
                    { name: "數學科常用單位換算表(小四)", src: `${LEGACY_PDF}/pdf/ms/4.doc` },
                    { name: "數學科常用單位換算表(小五)", src: `${LEGACY_PDF}/pdf/ms/5.doc` },
                    { name: "數學科常用單位換算表(小六)", src: `${LEGACY_PDF}/pdf/ms/6.doc` },
                ]}
            />,
        ],
    },
    { type: "custom", node: <br /> },
    { type: "custom", node: <br /> },
    {
        type: "paragraph",
        title: "B. 自學影片(數學科)匯集",
        titleSize: "h5",
        data: [
            <MainCard
                src={mathsImg.resources1}
                noImgPopup={true}
                sx={{ width: "60%" }}
                onClick={() =>
                    window.open("http://www.pkps.edu.hk/math_video/", "_blank", "noopener,noreferrer")
                }
            />,
        ],
    },
    { type: "custom", node: <br /> },
    { type: "custom", node: <br /> },
    {
        type: "paragraph",
        title: "C. 自主學習數學科圖書推介書目",
        titleSize: "h5",
        data: [
            <MaterialList
                data={[
                    {
                        name: "培小圖書館藏:數學科自學圖書書目",
                        src: `${LEGACY_PDF}/excel/ms/book.XLS`,
                    },
                ]}
            />,
        ],
    },
    { type: "custom", node: <br /> },
    { type: "custom", node: <br /> },
    {
        type: "paragraph",
        title: "D. 數學奇兵大搜查",
        titleSize: "h5",
        data: [
            <MainCard
                src={mathsImg.resources2}
                noImgPopup={true}
                sx={{ width: "60%" }}
                onClick={() =>
                    window.open(
                        "http://www.pkps.edu.hk/09-10%20teachplan/final/MSBK.html",
                        "_blank",
                        "noopener,noreferrer"
                    )
                }
            />,
        ],
    },
    { type: "custom", node: <br /> },
    { type: "custom", node: <br /> },
    {
        type: "paragraph",
        title: "E. 現代教育資源庫（學生版）",
        titleSize: "h5",
        data: [
            <MainCard
                src={mathsImg.resources3}
                noImgPopup={true}
                sx={{ width: "60%" }}
                onClick={() =>
                    window.open("https://www.mers.hk/login/gateway/pmath_st.php", "_blank", "noopener,noreferrer")
                }
            />,
        ],
    },
];
